import { useGetIdentity, useTranslate } from "ra-core";
import { Create } from "@/components/admin/create";
import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";

import { ShipmentInputs } from "./ShipmentInputs";
import type { Shipment } from "./types";

// invoice_number and total are filled by the database trigger; never trust client values.
const stripComputed = ({
  total: _t,
  invoice_number: _n,
  ...rest
}: Partial<Shipment>) => rest;

export const ShipmentCreate = () => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <div className="px-4 md:px-0">
      <Create
        title={translate("egi.shipments.new")}
        redirect="show"
        transform={(data: Partial<Shipment>) => ({
          ...stripComputed(data),
          sales_id: data.sales_id ?? identity?.id,
        })}
      >
        <SimpleForm
          className="max-w-5xl"
          defaultValues={{
            sales_id: identity?.id,
            tax: 0,
            items: [{ description: "", quantity: 1, unit_price: 0 }],
          }}
        >
          <ShipmentInputs />
        </SimpleForm>
      </Create>
    </div>
  );
};

export const ShipmentEdit = () => {
  const translate = useTranslate();
  return (
    <div className="px-4 md:px-0">
      <Edit
        title={translate("egi.shipments.edit")}
        redirect="show"
        mutationMode="pessimistic"
        transform={(data: Partial<Shipment>) => stripComputed(data)}
      >
        <SimpleForm className="max-w-5xl">
          <ShipmentInputs />
        </SimpleForm>
      </Edit>
    </div>
  );
};
